type AnimatedCheckMarkProps = {
  size?: number
}

export const AnimatedCheckMark = ({ size = 64 }: AnimatedCheckMarkProps) => {
  // const sizeClasses = size !== undefined ? `w-${size} h-${size}` : 'w-16 h-16'
  return (
    <svg
      style={{ width: size, height: size }}
      className={`rounded-full stroke-3 stroke-text-default`}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 52 52'
    >
      <circle
        className='stroke-background-default'
        cx='26'
        cy='26'
        r='25'
        fill='none'
      />
      <circle
        className={
          '[stroke-dasharray:166] [stroke-dashoffset:166] stroke-4 stroke-text-default fill-none animate-stroke'
        }
        cx='26'
        cy='26'
        r='25'
        fill='none'
      />
      <path
        className={
          '[stroke-dasharray:48] [stroke-dashoffset:48] animate-stroke-delayed'
        }
        fill='none'
        d='M14.1 27.2l7.1 7.2 16.7-16.8'
      />
    </svg>
  )
}
